
import { css } from 'lit';
export default css`
:host{
  --details-min-column-width:296px;

  display:block;
}

::slotted([slot='heading']){
  margin-bottom:var(--spacing-6);
}

.content{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4)
}

.contact{
  display:grid;
  gap:var(--spacing-6);
  margin-top:var(--spacing-6);
}

@media (min-width: 992px){

.contact{
    grid-template-columns:repeat(auto-fit, minmax(var(--details-min-column-width), 1fr));
    gap:var(--spacing-8)
}
  }

.phones-social{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

::slotted([slot='phones']){
  display:grid;
  gap:var(--spacing-6);
}

@media (min-width: 992px){

::slotted([slot='phones']){
    grid-template-columns:repeat(auto-fit, minmax(var(--details-min-column-width), 1fr))
}
  }

::slotted([slot='social']){
  display:flex;
  gap:var(--spacing-6);
}
`;